var BlockCat = {
	init:function(){
		var base_width = window.innerHeight * 0.6;
		var base_gap = 35;
		if(window.innerWidth < 990){
			base_width = 220;
			base_gap = 10;
		}
		var cat_nb = parseInt($('.tease-categorie').length);
		var total_w = (base_width*cat_nb)+(cat_nb*base_gap);
		$('.categories--list').width(total_w+'px');
		if(window.innerWidth > 990){
			BlockCat.init_slider(total_w, base_width);
		}

	},
	init_slider:function(total_w, base_width){
		var cats = gsap.utils.toArray(".tease-categorie");
		var scrollTween = gsap.to(cats, {
			xPercent: -100 * (cats.length - 2),
			ease: "none",
			scrollTrigger: {
				trigger: ".categories--list",
				pin: true,
				scrub: 0.1,
				end: "+="+total_w
			}
		});
	}
};

$(window).load(function(){
	if($(".block-categories").length){
		BlockCat.init();
	}
});
$(window).on('resize', function(){
	/*
	if($(".block-categories").length){
		BlockCat.init();
	}
	*/

});
